import script from "./MyDropdownLinkItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyDropdownLinkItem.vue?vue&type=script&lang=ts&setup=true"

import "./MyDropdownLinkItem.vue?vue&type=style&index=0&id=0e80ff30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e80ff30"]])

export default __exports__